/* UNIT WHEELS — pages d'information : sommaire, sections en cartes, mise en forme des politiques Shopify. */
(function () {
  if (window.__uLegal) return;
  window.__uLegal = true;

  var ARW = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function clean(s) { return s.replace(/\s*\((le cas échéant)\)\s*$/i, ''); }
  function key(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); }
  function slug(s, i) {
    var t = s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48);
    return 'u-s' + (i + 1) + (t ? '-' + t : '');
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function heading(text) { var h = el('h3'); h.textContent = text; return h; }

  /* titres écrits en MAJUSCULES sans accents (« ACCES AU SITE ») : on remet une casse normale + accents usuels */
  var ACC = { acces: 'accès', hebergeur: 'hébergeur', edition: 'édition', donnees: 'données', propriete: 'propriété', responsabilite: 'responsabilité', generales: 'générales', legales: 'légales', reglementation: 'réglementation', securite: 'sécurité', reclamations: 'réclamations', retractation: 'rétractation', creation: 'création', regles: 'règles', quelle: 'quelle' };
  function fixCase(t) {
    var s = t.toLowerCase().replace(/[a-zà-ÿ]+/g, function (w) { return ACC[w] || w; });
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  var UP = /[A-ZÀ-Ý]{3}/;
  // paragraphe « titre » : « 4. Prix », « EDITION DU SITE », « <span>1</span>ACCES AU SITE »
  function headingFromP(p) {
    if (p.tagName !== 'P') return null;
    var t = txt(p);
    if (!t || t.length > 80) return null;
    var f = p.firstElementChild;
    if (f && f.tagName === 'SPAN' && /^\d+$/.test(txt(f))) t = t.replace(/^\d+\s*/, '');
    var m = t.match(/^(\d{1,2})\s*[.)]\s+(\S.*)$/);
    if (m) t = m[2];
    else if (!(t === t.toUpperCase() && UP.test(t))) return null;
    if (t.length > 70 || /[.;:,!?]$/.test(t)) return null;
    if (t === t.toUpperCase() && UP.test(t)) t = fixCase(t);
    return clean(t);
  }

  /* ---- nettoyage du contenu ---- */
  function boldOnly(p) {
    if (p.tagName !== 'P') return false;
    var t = txt(p);
    if (!t || t.length > 90 || /[.:;!?]$/.test(t)) return false;
    var s = p.querySelector('strong, b');
    return !!s && txt(s) === t;
  }

  function expandParagraph(p) {
    var parts = p.innerHTML.split(/<br\s*\/?>/i).map(function (s) { return s.replace(/&nbsp;/g, ' ').trim(); }).filter(Boolean);
    if (parts.length < 2) return;
    var hasBullet = parts.some(function (s) { return /^\*\s+/.test(s); });
    var out = [], buf = [], list = null, changed = hasBullet;
    function flush() { if (buf.length) { out.push(el('p', '', buf.join('<br>'))); buf = []; } }
    parts.forEach(function (s, i) {
      var plain = s.replace(/<[^>]+>/g, '').trim();
      if (/^\*\s+/.test(s)) {
        flush();
        if (!list) { list = el('ul'); out.push(list); }
        list.appendChild(el('li', '', s.replace(/^\*\s+/, '')));
        return;
      }
      list = null;
      var prev = i > 0 ? parts[i - 1].replace(/<[^>]+>/g, '').trim() : '';
      if (i > 0 && plain.length <= 80 && !/[.:;,!?]$/.test(plain) && /^[A-ZÀ-ÖØ-Þ]/.test(plain) && /[.:!?)]$/.test(prev) && i < parts.length - 1) {
        flush(); out.push(heading(clean(plain))); changed = true; return;
      }
      buf.push(s);
    });
    flush();
    if (!changed) return;
    out.forEach(function (n) { p.parentNode.insertBefore(n, p); });
    p.remove();
  }

  function normalize(root) {
    root.querySelectorAll('hr').forEach(function (h) { h.remove(); });
    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      if (/^[-–—_=\s]{3,}$/.test(txt(p))) { p.remove(); return; }
      // <br> parasites en début/fin de paragraphe + espaces insécables qui cassent les retours à la ligne
      var h = p.innerHTML, c = h.replace(/&nbsp;| /g, ' ').replace(/^(\s|<br\s*\/?>)+/i, '').replace(/(\s|<br\s*\/?>)+$/i, '');
      if (c !== h) p.innerHTML = c;
    });
    // « 1. RETOURS » : liste d'un seul item en majuscules = titre de section
    Array.prototype.slice.call(root.querySelectorAll('ol')).forEach(function (ol) {
      var t = txt(ol);
      if (ol.children.length === 1 && t.length < 60 && t === t.toUpperCase() && ol.parentNode === root) {
        ol.parentNode.replaceChild(heading(t.charAt(0) + t.slice(1).toLowerCase()), ol);
      }
    });
    Array.prototype.slice.call(root.children).forEach(function (n) {
      var hp = headingFromP(n);
      if (hp) { n.parentNode.replaceChild(heading(hp), n); return; }
      if (boldOnly(n)) { n.parentNode.replaceChild(heading(clean(txt(n))), n); }
    });
    Array.prototype.slice.call(root.querySelectorAll(':scope > p')).forEach(expandParagraph);
  }

  /* ---- sections + sommaire ---- */
  function enhance(prose, tocList, grid) {
    normalize(prose);
    var kids = Array.prototype.slice.call(prose.children);
    var h2 = kids.filter(function (k) { return k.tagName === 'H2'; });
    var level = h2.length >= 2 ? 'H2' : 'H3';
    var heads = kids.filter(function (k) { return k.tagName === level; });

    if (heads.length < 2) { if (grid) grid.classList.add('is-solo'); return; }

    var frag = document.createDocumentFragment();
    var intro = el('div', 'u-lg-intro'), block = null, introUsed = false, blocks = [];
    kids.forEach(function (k) {
      if (k.tagName === level) {
        block = el('section', 'u-lg-block');
        block.appendChild(k);
        blocks.push({ node: block, head: k, label: clean(txt(k)) });
      } else if (block) {
        block.appendChild(k);
      } else {
        var kt = txt(k);
        if (/^(en vigueur|derni[eè]re mise [àa] jour|mis [àa] jour)/i.test(kt) && kt.length < 60) k.classList.add('u-lg-meta');
        intro.appendChild(k); introUsed = true;
      }
    });

    // doublons (même titre, contenu identique ou contenu inclus dans l'autre) : on garde le plus complet
    var byKey = {}, kept = [];
    blocks.forEach(function (b) {
      b.body = txt(b.node).slice(txt(b.head).length);
      var kk = key(b.label), prev = byKey[kk];
      if (prev && b.body && prev.body) {
        if (prev.body.indexOf(b.body) !== -1) return;
        if (b.body.indexOf(prev.body) !== -1) { kept[kept.indexOf(prev)] = b; byKey[kk] = b; return; }
      }
      byKey[kk] = b; kept.push(b);
    });

    kept.forEach(function (b, i) {
      var n = i + 1, id = slug(b.label, i);
      b.node.id = id;
      b.head.classList.add('u-lg-h');
      b.head.setAttribute('data-n', (n < 10 ? '0' : '') + n);
      if (/ne couvre pas|exclu/i.test(b.label)) b.node.classList.add('is-no');
      else if (/ce que couvre|produits? couverts?/i.test(b.label)) b.node.classList.add('is-yes');
      frag.appendChild(b.node);
      if (tocList) {
        var li = el('li'), a = el('a'), sp = el('span');
        a.href = '#' + id;
        sp.textContent = (n < 10 ? '0' : '') + n;
        a.appendChild(sp);
        a.appendChild(document.createTextNode(b.label));
        li.appendChild(a);
        tocList.appendChild(li);
      }
    });
    prose.innerHTML = '';
    if (introUsed && txt(intro)) prose.appendChild(intro);
    prose.appendChild(frag);

    // sommaire actif
    if (tocList && 'IntersectionObserver' in window) {
      var links = {};
      tocList.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            Object.keys(links).forEach(function (k) { links[k].classList.remove('is-active'); });
            var a = links[e.target.id];
            if (a) {
              a.classList.add('is-active');
              if (tocList.scrollWidth > tocList.clientWidth) { tocList.scrollTo({ left: Math.max(0, a.offsetLeft - 24), behavior: 'smooth' }); }
            }
          }
        });
      }, { rootMargin: '-22% 0px -68% 0px' });
      prose.querySelectorAll('.u-lg-block').forEach(function (b) { io.observe(b); });
      var first = tocList.querySelector('a'); if (first) first.classList.add('is-active');
    }
    if (tocList) {
      tocList.addEventListener('click', function (e) {
        var a = e.target.closest('a'); if (!a) return;
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + t.id);
      });
    }
  }

  /* ---- articles (section Liquid) ---- */
  function initArticle() {
    var prose = document.querySelector('[data-u-prose]');
    if (!prose) return false;
    var grid = prose.closest('.u-lg-grid');
    var toc = grid ? grid.querySelector('.u-lg-toc-l') : null;
    enhance(prose, toc, grid);
    return true;
  }

  /* ---- pages /policies/* ---- */
  function initPolicy() {
    var c = document.querySelector('.shopify-policy__container');
    if (!c) return false;
    var h1 = c.querySelector('.shopify-policy__title h1, h1');
    var body = c.querySelector('.shopify-policy__body .rte') || c.querySelector('.shopify-policy__body');
    if (!body) return false;
    var title = h1 ? txt(h1) : 'Informations';
    var wrap = el('div', 'u-lg');
    wrap.innerHTML =
      '<div class="u-lg-glow" aria-hidden="true"></div>' +
      '<div class="u-wrap">' +
        '<header class="u-lg-hero">' +
          '<p class="u-eyebrow">Informations</p>' +
          '<h1 class="u-lg-title"></h1>' +
        '</header>' +
        '<div class="u-lg-grid">' +
          '<nav class="u-lg-toc" aria-label="Sommaire"><p class="u-lg-toc-t">Sommaire</p><ol class="u-lg-toc-l"></ol></nav>' +
          '<article class="u-lg-prose" data-u-prose></article>' +
        '</div>' +
        '<aside class="u-lg-cta">' +
          '<div><h2>Une question ?</h2><p>Notre équipe vous répond directement : commande, retour, garantie ou personnalisation.</p></div>' +
          '<div class="u-lg-cta-actions"><a class="u-btn" href="/pages/contact">Nous contacter ' + ARW + '</a><a class="u-lg-cta-mail" href="mailto:contact@unit-wheels.com">contact@unit-wheels.com</a></div>' +
        '</aside>' +
      '</div>';
    wrap.querySelector('.u-lg-title').textContent = title;
    var prose = wrap.querySelector('[data-u-prose]');
    prose.innerHTML = body.innerHTML;
    // 1er paragraphe = simple répétition du titre de la page → retiré
    var f = prose.firstElementChild;
    if (f && f.tagName === 'P' && key(txt(f)) === key(title)) f.remove();
    c.parentNode.replaceChild(wrap, c);
    enhance(prose, wrap.querySelector('.u-lg-toc-l'), wrap.querySelector('.u-lg-grid'));
    return true;
  }

  function run() { if (!initArticle()) initPolicy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();